import {Kpi} from '@hconnect/common/types'
import {useNotification} from '@hconnect/uikit'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '@settings/api/mutations'
import type {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

export const useCreateKpi = (onSuccess: (data: Kpi) => void) => {
  const {t} = useTranslation()
  const {notify} = useNotification()
  const raiseError = useErrorHandler()

  return useMutation<Kpi, AxiosError<ErrorResponse>, Parameters<typeof mutations.createKpi>[0]>({
    mutationFn: mutations.createKpi,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.message, raiseError, notify)
    },
    onSuccess: (data) => {
      notify('success', t('success.createKpi'))
      onSuccess(data)
    }
  })
}
